<template>
    <div v-wechat-title="title" class="form-table-h380">
        <crud-facecade
            ref="template-list"
            :url="url"
            :columns="columnList"
            :buttons="[]"
            dialogWidth="80%"
            :addButton="{ permission: 'supplies_template:create' }"
            :updateButton="{ enabled: false, permission: 'supplies_template:update' }"
            @loadingSaveAsView="loadingSaveAsView"
        >
            <slot slot="filter">
                <el-col :md="6" :xl="4" class="padding-right10">
                    <item-input type="groupselect" v-model="dic_ward_id" :options="ward_auth" placeholder="请选择区域"></item-input>
                </el-col>
            </slot>
        </crud-facecade>
        <SaveAs :visible.sync="saveas.dialogFormVisible" :data="saveas.data" @save-success="saveAsSuccess"></SaveAs>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import SaveAs from './SaveAs.vue'
export default {
    name: `SuppliesTemplate`,
    components: { SaveAs },
    props: {},
    data() {
        return {
            title: `耗材模板`,
            o_dic_ward_id: undefined,
            issetoperatingward: false,
            applytype: this.$route.query.applytype,
            saveas: {
                dialogFormVisible: false,
                data: {}
            },
            url: {
                baseURL: `/api/AcisSystem/SuppliesTemplate`,
                get: () => {
                    let that = this
                    return new Promise((resolve, reject) => {
                        that.loadTemplates(resolve, reject)
                    })
                },
                getOne: row => {
                    return this.loadOne(row)
                },
                post: row => {
                    return this.saveOne(row, `post`)
                },
                put: row => {
                    return this.saveOne(row, `put`)
                }
            }
        }
    },
    created() {
        // this.$store.dispatch("ADD_WARD_AUTH")
    },
    computed: {
        ...mapGetters([`ward_auth`, `currentUser`, `active_ward`]),
        dic_ward_id: {
            get: function() {
                if (!this.issetoperatingward && this.active_ward) {
                    this.o_dic_ward_id = this.active_ward.value
                }
                return this.o_dic_ward_id
            },
            set: function(v) {
                this.o_dic_ward_id = v
                this.issetoperatingward = true
            }
        },
        saveAsColumns() {
            return _.filter(this.columnList, { isCreatable: true })
        },
        columnList() {
            let me = this
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    // width: "180",
                    isListable: false,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `name`,
                    label: `名称`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    colspan: 6,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `radio`,
                    prop: `region_type`,
                    label: `可用范围`,
                    width: `100`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    colspan: 4,
                    options: `enum_region_type`,
                    default: 1,
                    change: (that, { row }) => {
                        if (row.region_type == 2) {
                            if (!row.dic_ward_ids) {
                                var ids = []
                                ids.push(this.active_ward.value)
                                row.dic_ward_ids = ids
                            }
                        }
                    }
                },
                {
                    type: `radio`,
                    prop: `template_type`,
                    label: `模版类型`,
                    width: `100`,
                    isListable: !this.applytype,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    colspan: 4,
                    options: this.applytype == 1 ? [{ value: 1, label: `麻醉` }]
                        : (this.applytype == 2 ? [{ value: 2, label: `护理` }] : [
                            { value: 1, label: `麻醉` },
                            { value: 2, label: `护理` }
                        ]),
                    default: this.applytype || 1
                },
                {
                    type: `string`,
                    prop: `abbr`,
                    label: `缩写`,
                    width: `180`,
                    isListable: false,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    searchable: false
                },
                {
                    type: `groupmultiselect`,
                    prop: `dic_ward_ids`,
                    label: `可用区域`,
                    // width: "180",
                    isListable: true,
                    isEditable: true,
                    isCreatable: true,
                    colspan: 6,
                    options: this.ward_auth,
                    readonly: function(that, { row, column, area }) {
                        if (area == `form`) {
                            return row.region_type === 1
                        } else {
                            return true
                        }
                    }
                },
                {
                    type: `string`,
                    prop: `creator`,
                    label: `创建人`,
                    width: `100`,
                    isListable: true
                },
                {
                    type: `datetime`,
                    prop: `create_date`,
                    label: `创建时间`,
                    width: `140`,
                    isListable: true,
                    sortable: `desc`
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: `操作`,
                    width: `200`,
                    isListable: true,
                    readonly: false,
                    options: function(that, { row }) {
                        if (row.enum_surgery_status !== -1) {
                            return [
                                {
                                    class: `is-plain`,
                                    label: `编辑`,
                                    icon: ``,
                                    type: `primary`,
                                    emit: `LoadingUpdateView`,
                                    permission: `supplies_template:update`
                                },
                                {
                                    class: `is-plain`,
                                    label: `另存为`,
                                    icon: ``,
                                    type: `primary`,
                                    emit: `loadingSaveAsView`,
                                    permission: `default`
                                },
                                {
                                    class: `is-plain`,
                                    label: `删除`,
                                    icon: ``,
                                    type: `danger`,
                                    emit: `DeleteData`,
                                    permission: `default`
                                }
                            ]
                        } else {
                            return [
                                {
                                    label: `编辑`,
                                    icon: ``,
                                    type: `primary`,
                                    emit: `LoadingUpdateView`,
                                    permission: `supplies_template:update`
                                }
                            ]
                        }
                    }
                },
                {
                    type: `table`,
                    prop: `supplies`,
                    label: `耗材`,
                    isEditable: true,
                    isCreatable: true,
                    options: [
                        {
                            type: `string`,
                            prop: `id`,
                            label: `排序`,
                            isKey: true
                        },
                        {
                            type: `number`,
                            prop: `display_order`,
                            label: `排序`,
                            isListable: true,
                            readonly: false,
                            default: 1
                        },
                        {
                            type: `remoteselect`,
                            prop: `dic_supplies`,
                            label: `名称`,
                            width: `400`,
                            isListable: true,
                            readonly: false,
                            options: `/api/AcisSystem/Supplies/SearchSpec?applytype=${me.applytype || 0}`
                        },
                        {
                            type: `number`,
                            prop: `quantity`,
                            label: `数量`,
                            isListable: true,
                            readonly: false,
                            default: 1
                        }
                    ],
                    colspan: 24,
                    default: []
                }
            ]
        }
    },
    methods: {
        loadTemplates(resolve, reject) {
            // 加载可用模板
            let that = this
            let req = that.myaxios.get(`/api/AcisSystem/SuppliesTemplate/GetByTemplateType?TemplateType=${that.applytype}`)
            req.then(data => {
                let groupId = _.groupBy(data, `id`)
                let templates = []
                _.forEach(groupId, g => {
                    let r = { ...g[0] }
                    r.dic_ward_ids =
                        !r.owner &&
                        g.map(d => {
                            return (d.dic_operating_ward_id && `ow_${d.dic_operating_ward_id}`) || (d.dic_recovery_ward_id && `rw_${d.dic_recovery_ward_id}`)
                        })
                    r.region_type = r.owner ? 1 : 2
                    if (that.dic_ward_id) {
                        if (_.includes(r.dic_ward_ids, that.dic_ward_id) || r.region_type == 1) {
                            templates.push(r)
                        }
                    } else {
                        templates.push(r)
                    }
                    // console.log(templates)
                    resolve(templates)
                })
            }).catch(e => reject(e))
        },
        loadOne(row) {
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/AcisSystem/SuppliesTemplate/TemplateItems/${row.id}`)
                req.then(data => {
                    let dd = { ...row }
                    dd.supplies =
                        data.map(d => {
                            let r = { ...d.supplies }
                            Object.assign(r, {
                                id: d.id,
                                dic_supplies: { value: d.dic_supplies_id, label: r.name, jianpin: r.abbr },
                                dic_supplies_id: d.dic_supplies_id,
                                quantity: d.quantity,
                                display_order: d.display_order
                            })
                            return r
                        }) || []
                    resolve(dd)
                }).catch(e => reject(e))
            })
        },
        saveOne(row, tp) {
            // let that = this
            //   return new Promise((resolve,reject)=>{
            //     let req = this.myaxios.put(`/api/AcisSystem/SuppliesTemplate/Put`,{
            //       "id": row.id,
            //       "name": row.name,
            //       "items":_.reduce(_.groupBy(row.supplies,'dic_supplies.value'),function(result,value,key){
            //         let sOne = _.find(value,d=>{ return d.id>0})||value[0]
            //         let r ={
            //           "id":sOne.id,
            //           "sys_supplies_template_id": row.id,
            //           "dic_supplies_id": key,
            //           "quantity": _.sumBy(value,'quantity'),
            //           "display_order": sOne.display_order
            //         }
            //         result.push(r)
            //         return result
            //       },[]),
            //       "regions": row.region_type ==1?[{"owner":that.currentUser.username}]:row.dic_ward_ids.map(d=>{
            //         return {
            //           "sys_supplies_template_id": row.id,
            //           "dic_operating_ward_id": _.startsWith(d,'ow_')?d.substr(3):0,
            //           "dic_recovery_ward_id": _.startsWith(d,'rw_')?d.substr(3):0
            //         }
            //       })
            //     })
            //     req.then(data=>{
            //       resolve(data)
            //     }).catch(e=>reject(e))
            //   })
            return new Promise((resolve, reject) => {
                let req = this.myaxios[tp](`/api/AcisSystem/SuppliesTemplate/${tp}`, {
                    id: row.id,
                    name: row.name,
                    template_type: row.template_type,
                    items: _.reduce(
                        _.groupBy(
                            _.filter(row.supplies, d => d.dic_supplies && d.dic_supplies.value),
                            `dic_supplies.value`
                        ),
                        function(result, value, key) {
                            let sOne =
                                _.find(value, d => {
                                    return d.id > 0
                                }) || value[0]
                            let r = {
                                id: sOne.id,
                                sys_supplies_template_id: row.id,
                                dic_supplies_id: key,
                                quantity: _.sumBy(value, `quantity`),
                                display_order: sOne.display_order
                            }
                            result.push(r)
                            return result
                        },
                        []
                    ),
                    regions:
                        row.region_type == 1
                            ? [{ owner: this.currentUser.username }]
                            : row.dic_ward_ids.map(d => {
                                return {
                                    // "sys_supplies_template_id": 0,
                                    dic_operating_ward_id: _.startsWith(d, `ow_`) ? d.substr(3) : 0,
                                    dic_recovery_ward_id: _.startsWith(d, `rw_`) ? d.substr(3) : 0
                                }
                            })
                })
                req.then(data => {
                    resolve(data)
                }).catch(e => reject(e))
            })
        },
        ReloadListData() {
            let that = this
            that.$refs[`template-list`].ReloadListData()
        },
        loadingSaveAsView({ row }) {
            this.loadOne(row)
                .then(data => {
                    let r = { ...data }
                    this.saveas.dialogFormVisible = true
                    r.name = ``
                    r.id = 0
                    this.saveas.data = r
                })
                .catch(e => {
                    console.log(e)
                })
        },
        saveAsSuccess() {
            this.ReloadListData()
        }
    },
    watch: {
        dic_ward_id: function() {
            this.ReloadListData()
        }
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dictionary/Supplies/Template.vue